import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  Button as MatButton,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader, {
  BreadcrumbsModel,
} from "../../../../shared/PageHeader/PageHeader";
import PageWrapper from "../../../../shared/PageWrapper/PageWrapper";
import Button from "../../../../components/Button/Button";
import { useState } from "react";
import { getUser } from "../../../../utils/types";
import moment from "moment";

const breadcrumbs: BreadcrumbsModel[] = [
  { name: "Candidate Management", route: "/admin/candidate-management" },
  { name: "View", route: "/admin/candidate-management/view" },
  { name: "Upcoming Interview" },
];

const CandidateManagementUpcomingView = () => {
  const navigate = useNavigate();
  const loggedUserdata = getUser();
  const state = useLocation();

  const formatTime = (date: any, startime: any) => {
    if (date === "NA") {
      return "NA";
    }

    // Combine date and time correctly
    const combinedDateTime = `${moment(date).format("YYYY-MM-DD")}T${startime}`;

    // Format the final date and time
    const finalTime = `${moment(combinedDateTime).format(
      "DD-MM-YYYY"
    )}, ${moment(combinedDateTime).format("h.mm A")}`;

    return finalTime;
  };

  const checkInterviewerName = (interviewers: any) => {
    const hasValidInterviewer = interviewers.some(
      (interviewer: any) =>
        interviewer?.interviewer_name !== null &&
        interviewer?.interviewer_name !== undefined
    );

    return hasValidInterviewer
      ? interviewers?.map((val: any, index: number) => {
          return <Box>{val?.interviewer_name || "NA"}</Box>;
        })
      : "NA";
  };
  return (
    <PageWrapper>
      <PageHeader breadcrumbs={breadcrumbs} title="Upcoming Interview">
        <Button
          variant="secondary"
          variantType="contained"
          label="Back To List"
          onClick={() => {
            if (state?.state?.view === "calender") {
              navigate("/admin/candidate-management/calender-view", {
                ...state?.state,
              });
            } else {
              navigate("/admin/candidate-management/view", { ...state?.state });
            }
          }}
        />
      </PageHeader>
      <Card className="custom__card" sx={{ marginTop: "1.5rem" }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={3} marginBottom={4}>
              <Typography variant="body1">Position Title</Typography>
              <Typography variant="subtitle2">
                {state?.state?.calenderData?.position_name || "NA"}
              </Typography>
            </Grid>
            <Grid item xs={3} marginBottom={4}>
              <Typography variant="body1">Position Status</Typography>
              <Typography variant="subtitle2">
                {
                  state?.state?.calenderData?.application_id
                    ?.application_display_status
                }
              </Typography>
            </Grid>
            <Grid item xs={3} marginBottom={4}>
              <Typography variant="body1">Applied Date</Typography>
              <Typography variant="subtitle2">
                {moment(
                  state?.state?.calenderData?.application_id?.application_date
                ).format("DD-MM-YYYY")}
              </Typography>
            </Grid>
            <Grid item xs={3} marginBottom={4}>
              <Typography variant="body1">Date & Time</Typography>
              <Typography variant="subtitle2">
                {formatTime(
                  state?.state?.calenderData?.slot_date,
                  state?.state?.calenderData?.start_time
                )}
              </Typography>
            </Grid>
            <Grid item xs={3} marginBottom={4}>
              <Typography variant="body1">Interview Link</Typography>
              <Typography variant="subtitle2">
                {state?.state?.calenderData?.webex_link || "NA"}
              </Typography>
            </Grid>
            <Grid item xs={3} marginBottom={4}>
              <Typography variant="body1">Panel Name</Typography>
              <Typography variant="subtitle2">
                {checkInterviewerName(
                  state?.state?.calenderData?.interview_panel
                )}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </PageWrapper>
  );
};
export default CandidateManagementUpcomingView;
